import PropTypes from "prop-types"
import React from "react"

import { getDateFilterText } from "../helpers"
import { reportGeneratedText, statusFilterText } from "./helpers"

const Footer = ({ startDate, endDate, statusFilters = [], selectionText }) => {
  return (
    <div
      data-testid="print-view-footer"
      className="border-t-2 !border-gray-600"
    >
      <div className="flex flex-row space-x-4 py-4 italic !text-gray-600">
        <div>{reportGeneratedText()}</div>
        {selectionText ? (
          <div>{selectionText}</div>
        ) : (
          <>
            <div>{getDateFilterText(startDate, endDate)}</div>
            <div>{statusFilterText(statusFilters)}</div>
          </>
        )}
      </div>
    </div>
  )
}

Footer.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  statusFilters: PropTypes.arrayOf(PropTypes.string),
  selectionText: PropTypes.string,
}

export default Footer
